.wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--space-1-5);
}

.zone {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-2);
  min-height: 148px;
  padding: var(--space-6) var(--space-4);
  border: 1.5px dashed var(--color-border-strong);
  border-radius: var(--radius-lg);
  background: var(--color-surface-sunken);
  text-align: center;
  cursor: pointer;
  transition:
    border-color var(--duration-fast) var(--ease-standard),
    background-color var(--duration-fast) var(--ease-standard);
}

.zone:hover,
.dragging {
  border-color: var(--color-accent);
  background: var(--color-accent-soft);
}

.input {
  position: absolute;
  width: 1px;
  height: 1px;
  opacity: 0;
  pointer-events: none;
}

.wrapper:has(.input:focus-visible) .zone {
  outline: var(--focus-ring-width) solid var(--color-focus);
  outline-offset: 2px;
}

.invalid {
  border-color: var(--color-danger);
}

.disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.icon {
  color: var(--color-accent-text);
}

.label {
  max-width: 100%;
  overflow-wrap: anywhere;
  font-weight: var(--weight-medium);
}

.hint {
  color: var(--color-text-muted);
  font-size: var(--text-sm);
}

.error {
  color: var(--color-danger-text);
  font-size: var(--text-sm);
}
